module.exports = __webpack_public_path__ + "img/9788954619233.50a6e4d8.jpg";